export default "__VITE_ASSET__qnZ1kE9I__"